import React from 'react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
export function Hero() {
  return <Section className="min-h-[80vh] flex items-center justify-center text-center pt-24 pb-24" data-id="element-108">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-109">
        <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-brand-primary uppercase bg-brand-primary/10 rounded-full" data-id="element-110">
          Psihoterapie Integrativă & Coaching
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-brand-text mb-8 leading-tight" data-id="element-111">
          De la anxietate și frică, la{' '}
          <span className="text-brand-primary italic" data-id="element-112">liniște interioară</span>{' '}
          și încredere.
        </h1>

        <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl leading-relaxed" data-id="element-113">
          Un proces profund și practic pentru oameni copleșiți de gânduri
          repetitive, neliniște, frici sau dependențe emoționale, care vor să-și
          armonizeze mintea cu corpul și să-și regăsească echilibrul interior
          prin Metoda 3S (Știință · Suflet · Spirit).
        </p>

        <div className="flex flex-col items-center space-y-4" data-id="element-114">
          <Button variant="accent" size="lg" className="shadow-lg shadow-brand-accent/20 hover:shadow-brand-accent/30 transition-all transform hover:-translate-y-1" data-id="element-115">
            Rezervă Sesiunea CADOU de Evaluare 1 la 1
          </Button>
          <span className="text-sm text-gray-500 font-medium" data-id="element-116">
            Confidențial. Clar. Fără judecată.
          </span>
        </div>
      </div>
    </Section>;
}